import React from 'react'
import { useBranchDetails, BranchDetailsProps } from './useBranchDetails'
import { useCustomTranslation } from 'hooks/useCustomTranslation'
import InnerTitleSection from 'components/InnerTitleSection/InnerTitleSection'
import ImagesGallery from './ImagesGallery/ImagesGallery'
import BranchDescription from './BranchDescription/BranchDescription'
import AnnualActivities from './AnnualActivities/AnnualActivities'
import BranchNotFound from './BranchNotFound/BranchNotFound'
import Loader from 'components/Loader/Loader'

const BranchDetails: React.FC<BranchDetailsProps> = (
  props: BranchDetailsProps
) => {
  const { isLoading, branchDetails } = useBranchDetails(props)

  const { t, i18n } = useCustomTranslation()
  const currentLanguage = i18n.language
  const isAr = currentLanguage === 'ar'

  return isLoading ? (
    <Loader />
  ) : (
    <main>
      <InnerTitleSection
        title={
          branchDetails && branchDetails.length
            ? isAr
              ? branchDetails[0].subTitleAr
              : branchDetails[0].subTitleEn
            : t('branchDetails')
        }
        breadcrumbs={[
          {
            title: t('navHome'),
            link: '/',
          },
          {
            title: t('navOurBranches'),
            link: '/OurBranches',
          },
          {
            title:
              branchDetails && branchDetails.length
                ? isAr
                  ? branchDetails[0].subTitleAr
                  : branchDetails[0].subTitleEn
                : t('branchDetails'),
          },
        ]}
      />
      {branchDetails && branchDetails.length ? (
        <div>
          <BranchDescription
            title={isAr ? branchDetails[0].titleAr : branchDetails[0].titleEn}
            description={
              isAr
                ? branchDetails[0].descriptionAr
                : branchDetails[0].descriptionEn
            }
          />
          <ImagesGallery gallery={branchDetails[0].imagesGallery} />
          <AnnualActivities
            title={t('annualActivities')}
            activities={
              isAr
                ? branchDetails[0].annualActivitiesAr
                : branchDetails[0].annualActivitiesEn
            }
          />
        </div>
      ) : (
        <BranchNotFound
          message={isLoading ? `${t('loading')}...` : t('noData')}
        />
      )}
    </main>
  )
}

export default BranchDetails
